import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { bidAPI } from '../services/api';
import './MyBids.css';

const MyBids = () => {
  const [bids, setBids] = useState([]);
  const [loading, setLoading] = useState(true);
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    loadMyBids();
  }, []);

  const loadMyBids = async () => {
    try {
      const response = await bidAPI.getMyBids();
      setBids(response.data);
    } catch (error) {
      console.error('Error loading bids:', error);
      alert('Error al cargar tus ofertas');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteBid = async (bidId) => {
    if (window.confirm('¿Estás seguro de eliminar esta oferta?')) {
      try {
        await bidAPI.delete(bidId);
        alert('Oferta eliminada exitosamente');
        loadMyBids();
      } catch (error) {
        console.error('Error deleting bid:', error);
        alert('Error al eliminar la oferta');
      }
    }
  };

  const isWinning = (bid) => {
    return bid.amount === bid.highest_bid;
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Cargando ofertas...</p>
      </div>
    );
  }

  return (
    <div className="my-bids-container">
      <header className="my-bids-header">
        <h1>💰 Mis Ofertas</h1>
        <div className="header-actions">
          <button onClick={() => navigate('/')} className="btn-back">⬅️ Volver al Catálogo</button>
          <button onClick={() => { logout(); navigate('/login'); }} className="btn-logout">🚪 Salir</button>
        </div>
      </header>

      <div className="my-bids-content">
        {bids.length === 0 ? (
          <div className="no-bids">
            <h2>📭 No tienes ofertas activas</h2>
            <p>Explora el catálogo y haz tu primera oferta</p>
            <button onClick={() => navigate('/')} className="btn-browse">
              📱 Ver Catálogo
            </button>
          </div>
        ) : (
          <div className="bids-grid">
            {bids.map(bid => (
              <div key={bid.id} className={`bid-card ${isWinning(bid) ? 'winning' : ''} ${bid.vendido ? 'sold' : ''}`}>
                {isWinning(bid) && !bid.vendido && (
                  <div className="winning-badge">🏆 Oferta Ganadora</div>
                )}
                {bid.vendido && (
                  <div className="sold-badge">✅ VENDIDO</div>
                )}
                
                <div className="bid-phone-info">
                  <h3>{bid.marca} {bid.modelo}</h3>
                  {bid.imei && <p className="imei">IMEI: {bid.imei}</p>}
                </div>

                <div className="bid-details">
                  <div className="bid-amount-section">
                    <span className="label">Tu Oferta:</span>
                    <span className="my-bid">RD$ {parseFloat(bid.amount).toLocaleString()}</span>
                  </div>

                  <div className="bid-info-row">
                    <span className="label">Precio Base:</span>
                    <span>RD$ {parseFloat(bid.precio_base).toLocaleString()}</span>
                  </div>

                  <div className="bid-info-row">
                    <span className="label">Oferta Más Alta:</span>
                    <span className={isWinning(bid) ? 'winning-text' : ''}>
                      RD$ {parseFloat(bid.highest_bid).toLocaleString()}
                    </span>
                  </div>

                  <div className="bid-info-row">
                    <span className="label">Fecha:</span>
                    <span>{new Date(bid.created_at).toLocaleString('es-DO')}</span>
                  </div>
                </div>

                <div className="bid-actions">
                  <button 
                    onClick={() => navigate(`/phone/${bid.phone_id}`)} 
                    className="btn-view"
                  >
                    👁️ Ver Detalles
                  </button>
                  {!bid.vendido && (
                    <button 
                      onClick={() => handleDeleteBid(bid.id)} 
                      className="btn-delete-bid"
                    >
                      🗑️ Eliminar
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MyBids;
